import TextInputServerError from '@perpay-web/components/higher-order/WithFieldServerErrors/TextInputServerError';
import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';

const FormikTextInput = withFormikInputWrapper(TextInputServerError);

/**
 * @type { any }
 */
export default FormikTextInput;
